import React from 'react';
import { IProps as IBlockProps } from '@/blocks/BreadCrumbBlock/BreadCrumbBlock.interface';
import { BreadCrumbBlock } from '@/blocks/BreadCrumbBlock/BreadCrumbBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

// Define the specific input props structure expected by this translation layer
interface IBlockInputProps {
    items: Array<{
        text: string;
        target?: HTMLAnchorElement['target'];
        href: HTMLAnchorElement['href'];
        title?: string;
        ariaLabel?: string;
    }>;
    // Include other potential input fields if necessary
    [key: string]: any; // Allow passthrough of other props like block settings
}

// Define the mapping function from Input Props to BreadCrumbBlock Props
const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    // Extract blockWrapperProps from the input if they exist
    const { items, ...rest } = input;

    return {
        items: items.map((link) => ({
            text: link.text,
            target: link.target,
            url: link.href,
            title: link.title,
            ariaLabel: link.ariaLabel,
        })),
        ...rest, // Pass through remaining props to BlockWrapper
    };
};

// The component that uses the generic TranslationComponent
const BlockTranslation: React.FC<IBlockInputProps> = (props) => {
    return (
        <TranslationComponent
            inputProps={props}
            TargetComponent={BreadCrumbBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default BlockTranslation;